import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7f6603ac"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "value" };
const _hoisted_2 = { class: "title" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.value), 1),
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1)
    ]));
}
